<template>
  <div class="col-12 p-0">

          <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="tab_empty">
            <div class="row">


              <div class="col-6 p-0 p-t-25">
                <div class="row mb-3 font-13">
                  <div class="col"></div>
                  <div class="col">{{ this.pathwayName }}</div>
                  <div class="col text-right" v-if="!isReadOnly && isMasterAdmin == 0">
                    <button class="btn ma-blue-btn btn-md input-height-15 rounded editbtn" @click="onSubmit()">Edit Pathway</button></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div v-for="(step, index) in pathway_step_obj.steps">
                    <div class="pathways_step rounded shadow mb-3 bg-white b-r-15">
                      <div class="pathways_step_title border-bottom">
                        <div class="row">
                          <div class="col-3">
                            <div class="px-3 py-2">Step {{ parseInt(index + 1) }} - </div>
                          </div>
                          <div class="col-5 font-weight-bold text-center">
                            <div class="px-3 py-2" v-if="step.stepTitle != ''">{{ step.stepTitle }} </div>
                            <div class="px-3 py-2" v-else>Name of step </div>
                          </div>
                          <div class="col-4 text-right">
                            <div class="px-3 py-2">Objectives - {{ step.objective.length }}</div>
                          </div>
                        </div>
                      </div>

                      <!-- Pathway Objective -->
                      <div v-for="(objective, oindex) in step.objective">
                      <div class="pathways_step_item border-bottom">
                        <div class="row">
                          <div class="col-2">
                            <div class="pl-3 py-2 text-right">

                              <h5 class="mb-0" v-if="objective.objectiveType == 'Assessment'">
                                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'Course'">
                                <i class="fa fa-wrench" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'External Course'">
                                <i class="fa fa-wrench" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'Task List'">
                                <i class="fa fa-list-ul" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'Form'">
                                <i class="fa fa-file-text" aria-hidden="true"></i>
                              </h5>

                              <h5 class="mb-0" v-else-if="objective.objectiveType == 'Certificate'">
                                <i class="fa fa-certificate" aria-hidden="true"></i>
                              </h5>



                            </div>
                          </div>
                          <div class="col-8">
                            <div class="pl-3 py-2">{{ objective.objectiveName }}</div>
                          </div>
                          <div class="col-2 text-center">
                            &nbsp;
                          </div>
                        </div>
                      </div>
                      </div>
                      <!-- End Pathway Objective -->


                    </div>
                    </div>




                  </div>
                </div>

              </div>
            </div>
          </div>    

  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from '../../store/store';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { Validator } from "vee-validate";

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
      props: ['accountId', 'pathwayId'],
      data() {
        return {
          pathway_step_obj: {
            pathway: [],
            steps: [],
            removed_objective: [],
          },
          pathwayName: '',
          addStepModalVisible: false,
          addObjectiveModalVisible: false,
          stepTitle: '',
          stepDescription: '',
          stepIndex: '',
          objectiveIndex: '',
          objectiveType: '',
          objectiveId: '',
          objectiveLoading: false,
          objectiveOptions: [],
          isMasterAdmin: 0,
        }
      },
      computed: {
        isReadOnly(){
          if (this.$store.state.enterprise_type === 'Readonly') {
            return true;
          } else {
            if (this.$store.state.switch_admin_enterprise_isreadonly) {
              return true;
            } else {
              return false;
            }
          }
        }
      },
      methods: {
        backToPathway() {
          this.$parent.selectedComponent = 'PathwaysTab';
        },
        onSubmit() {
          this.$parent.selectPathwayStepTab(this.pathwayId);
        },
        getPathwayStepDetails: function() {
          axios.get('/get-pathway-step-details', {
            params: {
              pathwayId: this.pathwayId,
            }
          })
          .then((resp) => {
              this.pathway_step_obj.pathway = resp.data.pathway;
              this.pathwayName = this.pathway_step_obj.pathway.name;
              this.pathway_step_obj.steps = resp.data.pathwayStep;
              this.isMasterAdmin = this.pathway_step_obj.pathway.isMasterAdmin;
              if(this.pathway_step_obj.steps.length == 0) {
                this.pathway_step_obj.steps.push({
                  id: '',
                  stepTitle: '',
                  stepDescription: '',
                  objective: [],
                  edit: false,
                  update: false,
                  modified: false,
                });
              }
              this.$store.dispatch('pathway_steps', this.pathway_step_obj);
           })
          .catch(error => {
            if(error.response.data.message == 'Access denied.') {
              router.push("/forbidden");
            }
          });

        },
      },
      created() {
        this.getPathwayStepDetails();
      },
}

</script>

<style scoped>
.fa-pencil {
  cursor: pointer;
}
.pathway_objectives_box .d-flex div {
  width: 85px;
  margin-bottom: 15px;
  cursor: pointer;
}
.pathway_objective_focus {
  color: #00ACEE !important;
  background-color: #f0f9fc !important;
  border-color: #6cc2e2 !important;
  border: 1px solid #6cc2e2 !important;
}
.custom-control-label {
  font-size: 14px;
  margin-top: 3px;

}
.custom-radio .custom-control-label::before {
  top: 3px;
}
.editbtn, .editbtn:hover, .editbtn:focus, .editbtn:active {
   font-size: 13px; padding: 5px 25px;border-radius: 15px !important; margin-top: -5px;
}
.pathways_step_item {
  background-color: #f0f9fc; border-color: #6cc2e2 !important; 
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/enterpriseadmin_showpathway.vue